module.exports = {
  // --Body
  $bodyBg: "#f9fafd",
  $bodyPaddingMobile: ".625rem",
  $bodyPaddingTablet: "1.25rem",
  $bodyPaddingDesktop: "2.5rem",

  // --Borders
  $borderRadius: ".25rem",
  $borderRadiusLg: ".375rem",
  $borderRadiusSm: ".2rem",
  $borderColor: "#dce6ed",

  // --Box-shadow
  $boxShadowStart: "rgba(145, 166, 182, .08)",
  $boxShadowStop: "rgba(0, 0, 0, .1)",

  // --Buttons
  $btnPaddingY: ".53125rem",
  $btnPaddingX: "1rem",
  $btnBorderWidth: ".0625rem",
  $btnFontSize: ".6875rem",
  $btnLineHeight: "1",
  $btnBorderRadius: ".1875rem",
  $btnFontWeight: "400",

  // --Cards
  $cardContainerPaddingX: "0",
  $cardContainerPaddingY: "1.125rem",
  $cardPaddingX: "1.25rem",
  $cardPaddingY: ".5rem",

  // --Colors
  $darkGreen: "#23696a",
  $greenLighter: "#2A8686",
  $green: "#329798",
  $blue: "#4dc9ff",
  $red: "#ff6b6b",
  $redLight: "#bd362F",
  $black: "#152435",
  $grayDarkest: "#313e4d",
  $grayDarker: "#4a5766",
  $gray: "#91a6b6",
  $grayLight: "#dce6ed",
  $grayLighter: "#edf2f6",
  $grayLightest: "#f9fafd",
  $orange: "#f5a623",
  $white: "#fff",
  $brownLight: "#f89406",
  $greenLight: "#51a351",
  $blueLight: "#2f96b4",
  $toastText: "#ccc",
  $toastShadow: "#999",

  // --Fonts
  $fontLight: "300",
  $fontRegular: "400",
  $fontMedium: "500",
  $fontBold: "700",

  // --Line-heights
  $lineHeightText: "1.4",

  // --Input
  $inputPaddingX: "0",
  $inputPaddingY: ".125rem",
  $inputColor: "#152435",
  $inputFontWeight: "300",
  $inputBorderColor: "#dce6ed",
  $inputBorderRadius: "0",
  $inputBorderFocus: "$blue",
  $inputLabelPadding: "4px",
  $inputLabelLargePadding: "16px",

  // --Shared
  $navbarHeight: "72px",
  $portfolioHeaderPadding: "38px",
  $portfolioHeaderPaddingMobile: "35px",

  // --Item padding (e.g. DropdownItem, SpaceCategory)
  $itemLineHeight: "15px",
  $itemPaddingX: "12px",
  $itemPaddingY: "7px",

  // -- Icon Sizes
  $iconDefault: "1rem",
  $iconXlarge: "2rem",
  $iconLarge: "1.5rem",
  $iconSmall: ".75rem",
  $iconXs: ".625rem",
  $iconXxs: ".5rem",
};
